import React, { useEffect } from 'react';
import Header from './common/Header';
import LandingPage from './components/LandingPage/LandingPage';
import GeolocationInstructions from './components/LandingPage/GeolocationInstructions';
import DriverInfoEntry from './components/DriverInfoEntry/DriverInfoEntry';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './routes/ProtectedRoute';
import Report from './components/Report/Report';
import TermsAndConditions from './components/TermsAndConditions/TermsAndConditions';
import { Provider } from 'react-redux';
import { LoadingAnimationProvider } from './contexts/LoadingAnimationContext';
import Store from './redux/store';
import { IntlProvider } from 'react-intl';
import { PrecheckProvider } from './contexts/PrecheckContext';
import { CustomModalProvider } from './contexts/CustomModalContext';
import messages from './language/messages';
import { useState } from 'react';
import './constants/consoleMessage.js';

function App() {
    const [selectedLanguage, setSelectedLanguage] = useState<'en' | 'es' | 'ru'>('en');

    const languages = [
        { label: 'English', languageCode: 'en', messages: messages.en },
        { label: 'Spanish', languageCode: 'es', messages: messages.es },
        { label: 'Russian', languageCode: 'ru', messages: messages.ru }
    ];

    useEffect(() => {
        localStorage.setItem('language', selectedLanguage);
    }, [selectedLanguage]);

    return (
        <Provider store={Store}>
            <LoadingAnimationProvider>
                <BrowserRouter>
                    <IntlProvider
                        locale="en"
                        defaultLocale="en"
                        messages={
                            languages.find((language) => language.languageCode === selectedLanguage)
                                ?.messages
                        }>
                        <PrecheckProvider>
                            <CustomModalProvider>
                                <div className="App">
                                    <Header
                                        selectedLanguage={selectedLanguage}
                                        setSelectedLanguage={setSelectedLanguage}
                                    />
                                    <Routes>
                                        <Route path="/" element={<LandingPage />} />
                                        <Route
                                            path="/geolocation"
                                            element={<GeolocationInstructions />}
                                        />
                                        <Route element={<ProtectedRoute />}>
                                            <Route
                                                path="/driverinfo"
                                                element={<DriverInfoEntry />}
                                            />
                                            <Route path="/TAC" element={<TermsAndConditions />} />
                                            <Route path="/report" element={<Report />} />
                                        </Route>
                                    </Routes>
                                </div>
                            </CustomModalProvider>
                        </PrecheckProvider>
                    </IntlProvider>
                </BrowserRouter>
            </LoadingAnimationProvider>
        </Provider>
    );
}

export default App;
